import './Programme.css';
import { ProgrammeCard } from './components';


export default function Programme({
    conference,
    selectedDay = null,
}) {
    const programme = conference?.programme ?? [];
    const settings = conference?.settings?.programme ?? {};

    if (settings.show !== true) {
        return '';
    }

    const showDayLabel = settings.showDayLabel ?? true;
    const showFullDate = settings.showFullDate ?? true;
    const showTimes = settings.showTimes ?? true;
    const showSpeakers = settings.showSpeakers ?? true;
    const showAffiliations = settings.showAffiliations ?? true;
    const showLocations = settings.showLocations ?? true;
    const showDescriptions = settings.showDescriptions ?? true;
    const showDayTabs = settings.showDayTabs ?? true;

    if (programme.length === 0) {
        return `
            <section id="programme" class="programme">
                <div class="container">
                    <h2 class="programme__title">Programme</h2>
                    <div class="schedule__empty">
                        Programme will be available soon.
                    </div>
                </div>
            </section>
        `;
    }

    const activeDay =
        programme.find(day => day.date === selectedDay)
        || programme[0];

    return `
        <section id="programme" class="programme">

            <div class="container">

                <h2 class="programme__title">
                    Programme
                </h2>

                ${
                    showDayTabs
                        ? `
                            <nav
                                class="programme-days"
                                aria-label="Conference programme days"
                            >
                                ${programme.map(day => `
                                    <button
                                        type="button"
                                        class="programme-day-tab${
                                            day.id === activeDay.id
                                                ? ' programme-day-tab--active'
                                                : ''
                                        }"
                                        data-programme-day="${day.id}"
                                    >
                                        <span class="programme-day-tab__label">
                                            ${day.label}
                                        </span>
                                    </button>
                                `).join('')}
                            </nav>
                        `
                        : ''
                }

                <div class="programme-content">
                    ${ProgrammeCard(activeDay, {
                        showDayLabel,
                        showFullDate,
                        showTimes,
                        showSpeakers,
                        showAffiliations,
                        showLocations,
                        showDescriptions,
                    })}
                </div>

            </div>

        </section>
    `;
}
